<template>
  <div class="diferenciais__lista">
    <ul class="row justify-content-center">
      <li class="col-md-6 col-12" v-for="(item, index) in items" :key="index">
        <div class="diferenciais__lista__box">
          <div class="diferenciais__lista__box__title">
            <h2 class="ui-subtitle ui-subtitle--uppercase">
              {{item.title}}
            </h2>
          </div>
          <div class="ui-description ui-description--italic lh-30">
            <p v-html="item.description">
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ['items']
}

</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.diferenciais__lista {
  li {
    margin-bottom: 30px;
  }
  &__box {
    background: white;
    border-radius: 10px;
    box-shadow: 20px 20px 35px 0px rgba(0, 26, 66, 0.2);
    height: 100%;
    padding: 80px 30px;
    &__title {
      margin-bottom: 20px;
      min-height: 65px;
    }
  }
  @media (max-width: 1200px) {
    .diferenciais__lista {
      &__box {
        padding: 20px 15px;
        &__title {
          margin-bottom: 10px;
          min-height: 30px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .diferenciais__lista {
      &__box {
        &__title {
          min-height: inherit;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DiferenciaisValoresCard.vue